import z from "zod";
import { webappClient } from "../clients";
import { validateResponse } from "../validation";

const featureFlagsResponseSchema = z.object({
  feature_toggles: z.array(
    z.object({
      name: z.string(),
    })
  ),
});

export async function fetchFeatureFlags() {
  const data = await webappClient.get("api/feature_toggles").json();
  const result = validateResponse({
    data,
    schema: featureFlagsResponseSchema,
    tag: "Feature flags response",
  });

  return result.feature_toggles;
}
